import conn from "@/store/utils/connection";
import customerAPI from "@/store/utils/api-route/customerAPI";
import resulter from "@/store/utils/resulter";
import state from "./state"

const actions = {
	queryFilter({rootGetters}) {
		let getFilter = rootGetters["filterGlobalModule/getFilter"]
		let getFilterItem = rootGetters["filterGlobalModule/getFilterItem"]
		let query = {
			sort_by: getFilter.sortBy,
			order_by: getFilter.orderBy,
			limit: state.pagination.limit,
			offset: state.pagination.offset,
			// kontak: getFilterItem.kontakKonsumen.length === 1 ? getFilterItem.kontakKonsumen[0] : "all",
		}
		// kontak
		if (getFilterItem.kontakKonsumen.length === 1) {
			query.kontak = getFilterItem.kontakKonsumen
		}
		// periode
		if (getFilterItem.periode.filterBy !== "") {
			query.filter_by = getFilterItem.periode.filterBy

			switch (getFilterItem.periode.filterBy) {
				case "periode":
					query.tanggal_awal = getFilterItem.periode.startDate
					query.tanggal_akhir = getFilterItem.periode.endDate
					break;
				case "bulan":
					query.bulan = getFilterItem.periode.month
					break;
				case "tahun":
					query.tahun = getFilterItem.periode.year
					break;
				default:
					break;
			}
		}
		// filter kolom
		getFilterItem.filterRentangTanggalKonsumen !== "" ?
			query.filter_kolom = getFilterItem.filterRentangTanggalKonsumen :
			query.filter_kolom = null
		// filter layanan
		getFilterItem.filterLayananOwner !== "" ?
			query.filter_layanan_by = getFilterItem.filterLayananOwner :
			query.filter_layanan_by = null

		// layanan
		if (getFilterItem.layananOwner.length > 0) {
			query.idlayanan_array = getFilterItem.layananOwner
		}
		// deposit
		if (getFilterItem.deposit.length > 0) {
			query.iddeposit_array = getFilterItem.deposit
		}
		// status deposit
		if (getFilterItem.statusDeposit.length > 0) {
			query.status_deposit = getFilterItem.statusDeposit
		}
		// outlet
		if (getFilterItem.outlet.length > 0) {
			query.outlet_array = getFilterItem.outlet
		}
		// filter saldo epayment
		if (getFilterItem.filterSaldoEpayment.minimal > 0) {
			query.min_epay = getFilterItem.filterSaldoEpayment.minimal
		}
		if (getFilterItem.filterSaldoEpayment.maksimal > 0) {
			query.max_epay = getFilterItem.filterSaldoEpayment.maksimal
		}
		if (getFilterItem.agama.length > 0) {
			query.agama = getFilterItem.agama
		}
		if (state.isSerachCustomer) {
			query.key = state.search.key
		}
		if (getFilterItem.idmaster_member.length > 0) {
			query.idmaster_member = getFilterItem.idmaster_member
		}
		query.type = getFilterItem.jenisKonsumen ?? undefined

		return query
	},

	// fetch data
	async fetchCustomer({commit, dispatch}) {
		try {
			let query = await dispatch("queryFilter")

			const res = await conn.get(customerAPI.list, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				await conn.setQueryString(query)
				commit("setCustomer", res.data);
				return resulter.successResult()
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},
	async fetchCustomerV2({commit, dispatch}) {
		try {
			let query = await dispatch("queryFilter")

			const res = await conn.get(customerAPI.listV2, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				await conn.setQueryString(query)
				commit("setCustomer", res.data);
				return resulter.successResult()
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},

	async fetchDetailCustomer({commit, dispatch}, id) {
		commit("resetDetailCustomer")
		try {
			let query = {
				idcustomer: id
			}
			const res = await conn.get(customerAPI.detail, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				commit("setDetailCustomer", res.data.data)
				return resulter.successResult()
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},

	async fetchTopFive({commit}, id) {
		try {
			let query = {
				idcustomer: id
			}
			const res = await conn.get(customerAPI.topFive, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				commit("setTopFive", res.data)
				return resulter.successResult()
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},

	async fetchRiwayat({commit}, id) {
		try {
			let query = {
				idcustomer: id
			}
			const res = await conn.get(customerAPI.riwayat, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				commit("setRiwayat", res.data)
				return resulter.successResult()
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},

	// alamat
	async fetchAlamatList({commit}, id) {
		try {
			let query = {
				idcustomer: id,
				limit: state.paginationAlamat.limit,
				offset: state.paginationAlamat.offset,
			}
			if (state.isSearchAlamat) {
				query.key = state.searchAlamat.key
			}

			const res = await conn.get(customerAPI.alamat.list, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				await conn.setQueryString(query)
				commit("setAlamat", res.data)
				return resulter.successResult()
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},

	// create
	async createCustomer({commit}) {
		try {
			const res = await conn.post(customerAPI.create, JSON.stringify(state.dataCreateCustomer), conn.contentType.json)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				commit("resetAlamatTemp")
				commit("resetPagination")
				commit("resetCustomer")
				return resulter.successResult(res.data.msg, res.data.data)
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},

	// create alamat
	async createAlamat({commit}, id) {
		try {
			let query = {idcustomer: id}
			let temp = JSON.parse(JSON.stringify(state.alamatTemp))
			temp.alamat_utama = (temp.alamat_utama.length > 0) ? "1" : "0"

			const res = await conn.post(customerAPI.alamat.create, JSON.stringify(temp), conn.contentType.json, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				return resulter.successResult(res.data.msg)
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},

	// update
	async updateCustomer({commit}, payload) {
		try {
			const res = await conn.patch(`${customerAPI.update.index}/${payload.idcustomer}`, payload)
			console.log(res);
			if (typeof res === 'string') {
                return resulter.errorResult(res)    
            }
			if (res.data.status) return resulter.successResult(res.data.msg)
			else return resulter.errorResult(res.data.msg)
		} catch (error) {
			return resulter.errorResult(error)
		}
	},
	processUpdate({commit}, payload) {
		if (payload.res.data.status) {
			commit("setDetailCustomer", payload.customer)
			return resulter.successResult(payload.res.data.msg)
		} else {
			return resulter.errorResult(payload.res.data.msg)
		}
	},
	async updateCustomerOutlet({commit, dispatch}, payload) {
		try {
			let query = {idcustomer: payload.idcustomer}
			let form = new FormData()
			form.append("idoutlet", payload.idoutlet)

			const res = await conn.post(customerAPI.update.outlet, form, conn.contentType.form, query)
			if (!res.data) {
				throw(res)
			}
			return await dispatch("processUpdate", {res: res, customer: payload})
		} catch (e) {
			return resulter.errorResult(e)
		}
	},
	async updateCustomerNama({commit, dispatch}, payload) {
		try {
			let query = {idcustomer: payload.idcustomer}
			let form = new FormData()
			form.append("nama", payload.nama_customer)
			form.append("sapaan", payload.sapaan)

			const res = await conn.post(customerAPI.update.nama, form, conn.contentType.form, query)
			if (!res.data) {
				throw(res)
			}
			return await dispatch("processUpdate", {res: res, customer: payload})
		} catch (e) {
			return resulter.errorResult(e)
		}
	},
	async updateCustomerJenisKelamin({commit, dispatch}, payload) {
		try {
			let query = {idcustomer: payload.idcustomer}
			let form = new FormData()
			form.append("jenis_kelamin", payload.jenis_kelamin)

			const res = await conn.post(customerAPI.update.jenisKelamin, form, conn.contentType.form, query)
			if (!res.data) {
				throw(res)
			}
			return await dispatch("processUpdate", {res: res, customer: payload})
		} catch (e) {
			return resulter.errorResult(e)
		}
	},
	async updateCustomerNomorTelepon({commit, dispatch}, payload) {
		try {
			let query = {idcustomer: payload.idcustomer}
			let form = new FormData()
			form.append("country_code", payload.country_code)
			form.append("telepon", payload.phone)

			const res = await conn.post(customerAPI.update.telepon, form, conn.contentType.form, query)
			if (!res.data) {
				throw(res)
			}
			return await dispatch("processUpdate", {res: res, customer: payload})
		} catch (e) {
			return resulter.errorResult(e)
		}
	},
	async updateCustomerInstansi({commit, dispatch}, payload) {
		try {
			let query = {idcustomer: payload.idcustomer}
			let form = new FormData()
			form.append("instansi", payload.instansi)

			const res = await conn.post(customerAPI.update.instansi, form, conn.contentType.form, query)
			if (!res.data) {
				throw(res)
			}
			return await dispatch("processUpdate", {res: res, customer: payload})
		} catch (e) {
			return resulter.errorResult(e)
		}
	},
	async updateCustomerTanggalLahir({commit, dispatch}, payload) {
		try {
			let query = {idcustomer: payload.idcustomer}
			let form = new FormData()
			form.append("tanggal_lahir", payload.tanggal_lahir_post)

			const res = await conn.post(customerAPI.update.tanggalLahir, form, conn.contentType.form, query)
			if (!res.data) {
				throw(res)
			}
			return await dispatch("processUpdate", {res: res, customer: payload})
		} catch (e) {
			return resulter.errorResult(e)
		}
	},
	async updateCustomerAgama({commit, dispatch}, payload) {
		try {
			let query = {idcustomer: payload.idcustomer}
			let form = new FormData()
			form.append("agama", payload.agama)

			const res = await conn.post(customerAPI.update.agama, form, conn.contentType.form, query)
			if (!res.data) {
				throw(res)
			}
			return await dispatch("processUpdate", {res: res, customer: payload})
		} catch (e) {
			return resulter.errorResult(e)
		}
	},
	async updateCustomerEmail({commit, dispatch}, payload) {
		try {
			let query = {idcustomer: payload.idcustomer}
			let form = new FormData()
			form.append("email", payload.email)

			const res = await conn.post(customerAPI.update.email, form, conn.contentType.form, query)
			if (!res.data) {
				throw(res)
			}
			return await dispatch("processUpdate", {res: res, customer: payload})
		} catch (e) {
			return resulter.errorResult(e)
		}
	},

	// update alamat
	async updateAlamat({commit}, payload) {
		try {
			let query = {
				idcustomer: payload.idcustomer,
				idalamat: payload.idalamat
			}
			let temp = JSON.parse(JSON.stringify(state.alamatTemp))
			temp.alamat_utama = (temp.alamat_utama.length > 0) ? "1" : "0"

			const res = await conn.post(customerAPI.alamat.update, temp, conn.contentType.json, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				return resulter.successResult(res.data.msg)
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},

	// delete
	async deleteCustomer({commit, dispatch}, id) {
		try {
			let query = {idcustomer: id}
			const res = await conn.post(customerAPI.delete, null, conn.contentType.json, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				return resulter.successResult(res.data.msg)
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},

	// delete alamat
	async deleteAlamat({commit}, payload) {
		try {
			let query = {
				idcustomer: payload.customer_idcustomer,
				idalamat: payload.idalamat
			}
			const res = await conn.post(customerAPI.alamat.delete, null, conn.contentType.json, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				return resulter.successResult(res.data.msg)
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},

	// import
	async importCustomer({commit}, payload) {
		try {
			let query = {force: payload.force}
			let form = new FormData()
			form.append("fileExcel", payload.fileExcel)
			const res = await conn.post(customerAPI.import, form, conn.contentType.multipart, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				return resulter.successResult(res.data.msg)
			} else {
				return resulter.errorResult(res.data.msg, res.data.data)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},

	// export
	async exportCustomer({commit, rootGetters}) {
		try {
			let getFilter = rootGetters["filterGlobalModule/getFilter"]
			let getFilterItem = rootGetters["filterGlobalModule/getFilterItem"]
			let query = {
				sort_by: getFilter.sortBy,
				order_by: getFilter.orderBy,
				kontak: getFilterItem.kontakKonsumen.length === 1 ? getFilterItem.kontakKonsumen[0] : "all",
			}
			if (state.isSerachCustomer) {
				query.key = state.search.key
			}
			const res = await conn.post(customerAPI.export, null, conn.contentType.json, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				return resulter.successResult()
			} else {
				return resulter.errorResult(res.data.msg, res.data.data)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},
	async deleteExportFileCustomer({commit}, filename) {
		try {
			let query = {filename: filename}
			const res = await conn.post(customerAPI.deleteExport, null, conn.contentType.json, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				return resulter.successResult()
			} else {
				return resulter.errorResult(res.data.msg, res.data.data)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},

	// tracker
	async importCustomerTracker() {
		try {
			let query = {timestamp: Date.now()}
			const res = await conn.post(customerAPI.importTrack, null, conn.contentType.json, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				return resulter.successResult("", res.data.data)
			} else {
				return resulter.errorResult(res.data.msg, res.data.data)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},
	async exportCustomerTracker() {
		try {
			let query = {timestamp: Date.now()}
			const res = await conn.post(customerAPI.exportTrack, null, conn.contentType.json, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				return resulter.successResult("", res.data.data)
			} else {
				return resulter.errorResult(res.data.msg, res.data.data)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},

	// export v2
	async export({commit, dispatch}, payload) {
		try {
			let query = await dispatch("queryFilter")
			let formData = new FormData
			formData.append("type", payload.type)
			formData.append("filter_json", JSON.stringify(query))

			const res = await conn.post(customerAPI.export.job, formData, conn.contentType.form)
			if (!res.data) {
				throw(res)
			}
			if (res.data.code === 200) {
				let keyExport = "export:job:customer:reguler"
				localStorage.setItem("key_export_customer_reguler", keyExport)
				return resulter.successResult(res.data.msg)
			} else {
				return resulter.errorResult(res.data.msg, res.data.data)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},

	async exportTrack({commit}) {
		try {
			let keyExport = localStorage.getItem("key_export_customer_reguler")
			if (keyExport === null) {
				return resulter.errorResult()
			}
			let query = {
				key: keyExport
			}
			const res = await conn.get(customerAPI.export.track, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				return resulter.successResult(res.data.msg, res.data.data)
			} else {
				return resulter.errorResult(res.data.msg, res.data.data)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},

	async exportDeleteCluster({commit}, key) {
		try {
			let query = {
				key: key
			}
			const res = await conn.get(customerAPI.export.delete.cluster, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.code === 200) {
				return resulter.successResult(res.data.msg, res.data.data)
			} else {
				return resulter.errorResult(res.data.msg, res.data.data)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},

	async exportDeleteMaster({commit}) {
		// localStorage.removeItem("key_export_customer_reguler")
		try {
			let keyExport = localStorage.getItem("key_export_customer_reguler")
			let query = {
				key: keyExport
			}
			const res = await conn.get(customerAPI.export.delete.master, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.code === 200) {
				localStorage.removeItem("key_export_customer_reguler")
				return resulter.successResult(res.data.msg, res.data.data)
			} else {
				return resulter.errorResult(res.data.msg, res.data.data)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},

	flush({commit}) {
		commit("resetCustomer")
		commit("resetPagination")
		commit("resetAlamatTemp")
		commit("resetDetailCustomer")
		commit("resetSearch")
		commit("resetAlamat")
		commit("resetDataCreateCustomer")
	}
}

export default actions